import { Action, createReducer, on } from '@ngrx/store';
import * as LocumsJobActions from '../actions/job.actions';
import { UnitDetails } from '../../../locums/models/unit-details.model';

export interface JobState {
    isLoading: boolean;
    unitDetails: UnitDetails;
    error: unknown;
}

export const initialJobState: JobState = {
    isLoading: false,
    unitDetails: null,
    error: undefined
};

export function jobReducer(state: JobState, action: Action) {
    return createReducer(
        initialJobState,

        on(LocumsJobActions.loadUnitDetails, (state, action) => ({
            ...state,
            isLoading: true
        })),

        on(LocumsJobActions.loadUnitDetailsFailure, (state, action) => ({
            ...state,
            isLoading: false,
            error: action.error
        })),

        on(LocumsJobActions.loadUnitDetailsSuccess, (state, action) => ({
            ...state,
            isLoading: false,
            unitDetails: action.unitDetails
        }))
    )(state, action);
}

export function reducer(state: JobState | undefined, action: Action) {
    return jobReducer(state, action);
}
